import React from 'react';

const PayoutStatusBadge = ({ invoice }) => {
  let statusText = 'Processing';
  let style = {
    background: 'var(--Blue-100)',
    color: 'var(--Blue-700)',
  }; // Default style for "Processing"

  // Check the main invoice status first
  if (invoice.status !== 'paid') {
    // If the invoice isn't even paid, there's no payout to track.
    return <span className="text-gray-400 text-xs">—</span>;
  }

  // Now, check our specific payout status from the webhook
  if (invoice.stripe?.payoutStatus === 'paid_out') {
    statusText = 'Paid Out';
    style = {
      background: 'var(--Green-100)',
      color: 'var(--Green-800)',
    };
  } else if (invoice.stripe?.payoutStatus === 'in_transit') {
    statusText = 'In Transit';
    style = {
      background: 'linear-gradient(135deg, var(--Blue-500), var(--Blue-600))',
      color: 'var(--Brand-White)',
    };
  }
  // In the future, you could add a case for 'in_transit' here.

  return (
    <span
      className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full"
      style={style}
    >
      {statusText}
    </span>
  );
};

export default PayoutStatusBadge;
